import { Button, Col, Row, Form } from 'antd';
import React, { ReactElement, useEffect, useState } from 'react';
import PageHeader from '../../../../shared/components/pageHeader/PageHeader';
import { GUTTOR_SPACE } from '../../../../shared/constants/commonConstants';
import { RECONCILIATION_DETAIL_NAV } from '../../../../shared/constants/reconciliationConstants';
import { base64UrlDecode } from '../../../../utils/utility';
import CustomFormStepper from '../../../crm/inPatient/newAdmission/panels/CustomFormStepper/CustomFormStepper';
import { getPreviousUrl } from '../../../crm/inPatient/service/crmUtils';
import ReconcilationStatusPanel from './cards/ReconcilationStatusPanel';
import ReconciliationDetailTimeLine from './cards/ReconciliationDetailTimeLine';
import { useDispatch, useSelector } from 'react-redux';
import { getReconciliationDetail, setIsReconciliationEditable, updateReconciliationData, setReconciliationClaimDetail,
  updatedReconciliationColsData as  updatedReconciliationColsDataAction } from '../../../../store/actions/reconciliationAction';
import { ReconciliationState } from '../../../../store/models/reconciliationModel';
import { RootState } from '../../../../store';
import { centeredNotification } from '../../../../utils/utility';

const ReconciliationClaimDetail = ({ match, location: { pathname } }: any): ReactElement => {
  const {isReconciliationEditable, updatedReconciliationColsData, reconciliationClaimDetail,
    viewId} = useSelector((state: RootState): ReconciliationState => state.reconciliation || []);
  const [selectedTab, setSelectedTab] = useState(0);
  const [reconForm] = Form.useForm();
  const { params: { data } } = match;
  const record = JSON.parse(base64UrlDecode(data));
  const dispatch = useDispatch();

  useEffect((): any => {
    dispatch(setReconciliationClaimDetail(record));
    const payload = {
      reconciliationMasterId: record.reconciliationMasterId,
      hospActionId: record.hospActionId,
      utrNumber: record.utrNumber,
    };
    dispatch(getReconciliationDetail(payload));
    dispatch(setIsReconciliationEditable(false));
  }, []);
  const onSave = (): any => {
    let validated = true;
    if (updatedReconciliationColsData.length <= 0) {
      centeredNotification('Please add data');
      validated = false;
      return;
    }
    updatedReconciliationColsData.forEach((el: any): any => {
      if (Object.values(el).includes('')) {
        centeredNotification('Please fill all the details');
        validated = false;
        return;
      }
    });
    const payload = {
      addReconciliationAuditTrail : updatedReconciliationColsData,
      viewId,
      hospActionId: reconciliationClaimDetail.hospActionId,
      payerClaimNo: reconciliationClaimDetail.payerClaimNoFinal,
    };
    if (validated) {
      dispatch(updateReconciliationData(payload));
      dispatch(setIsReconciliationEditable(false));
    }
  };
  const getAdmissionForm = (): ReactElement | null => {
      return (
        <CustomFormStepper
          form={reconForm}
          isRecon={true}
          detailNav={RECONCILIATION_DETAIL_NAV}
          selectedTab={selectedTab}
          setSelectedTab={setSelectedTab}
          className="normal-detail-panel-height"
        />
      );
    };

  return (
    <React.Fragment>
        <PageHeader pageTitle="Reconciliation Report"
          backUrl={getPreviousUrl(pathname)}
          rightComponent={(): ReactElement => <div>
            { selectedTab === 1 &&
              <Row gutter={GUTTOR_SPACE} justify="end">
                <Button className="ant-btn ant-btn-primary mr-10" type={'primary'} disabled={isReconciliationEditable} onClick={(): any => {
                  dispatch(setIsReconciliationEditable(true));
                }}>
                  Edit
                </Button>
                <Button className="ant-btn ant-btn-default mr-10" type={'ghost'} disabled={!isReconciliationEditable} onClick={(): any => {
                  onSave();
                }}>
                  Save
                </Button>
                <Button className="ant-btn ant-btn-default mr-10" type={'ghost'} disabled={!isReconciliationEditable} onClick={(): any => {
                  dispatch(setIsReconciliationEditable(false));
                  dispatch(updatedReconciliationColsDataAction([]));
                }}>
                  Cancel
                </Button>
              </Row> }
          </div>}
        />

     <div className="reconciliation ant-tabs-content-holder tab-custom-container pb-0">
     <Row gutter={GUTTOR_SPACE}>
       <Col md={16}>
         {getAdmissionForm()}
       </Col>
       <Col md={8}>
        <ReconcilationStatusPanel/>
        <ReconciliationDetailTimeLine />
       </Col>
     </Row>
   </div>
   </React.Fragment>
  );
};
export default ReconciliationClaimDetail;
